import { createFileRoute } from "@tanstack/react-router";
import { TeamsNotificationsPage } from "@features/communications/components/TeamsNotificationsPage";

export const Route = createFileRoute(
	"/_layout/communication/notifications/teams-notifications",
)({
	component: TeamsNotificationsPage,
	staticData: {
		crumb: {
			label: "Teams Notifications",
		},
	},
});
